import React, { useContext, useEffect } from 'react';

import { Box } from '@betterment/samba-react';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

import Notice from './Notice';
import { NoticesContext } from './NoticesProvider';

type Props = {
  css?: SystemStyleObject;
};

const NoticeCollection: React.FC<Props> = ({ css: cssProp }) => {
  const { notice, hasLoaded, fetchNotice } = useContext(NoticesContext);

  useEffect(() => {
    if (!hasLoaded) {
      void fetchNotice();
    }
  }, [hasLoaded, fetchNotice]);

  if (!notice) return null;

  return (
    <Box
      css={{
        display: 'grid',
        marginTop: {
          base: 'space.300',
          mdDown: 'space.100',
        },
        ...cssProp,
      }}
    >
      <Notice notice={notice} fetchNextNotice={fetchNotice} />
    </Box>
  );
};

export default NoticeCollection;
